export default function Card5Icon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path d="M8.002 12.213c3.995 0 6.656-3.218 6.656-4.204 0-.991-2.666-4.209-6.656-4.209-3.94 0-6.66 3.218-6.66 4.209 0 .986 2.715 4.204 6.66 4.204zm0-1.572a2.652 2.652 0 0 1-2.646-2.632c-.005-1.47 1.177-2.632 2.646-2.632A2.63 2.63 0 0 1 10.65 8.01c0 1.43-1.187 2.632-2.647 2.632zm0-1.631c.552 0 1.011-.454 1.011-1.001 0-.552-.459-1.006-1.01-1.006-.557 0-1.011.454-1.011 1.006a1.01 1.01 0 0 0 1.01 1.001z" fill="#383A3D" fillRule="nonzero" />
      </g>
    </svg>
  );
};
